import { useCallback, useEffect, useState } from "react";
import { fetchCompanyBeneficiary } from "../api/companyApi";
import type { CompanyBeneficiaryDetail } from "../api/types";
import { getAuthToken } from "../auth";

export function useEnterpriseBeneficiaryDetail(
  type: "employee" | "dependant",
  beneficiaryId: number,
) {
  const [beneficiary, setBeneficiary] = useState<CompanyBeneficiaryDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [usingApi, setUsingApi] = useState(false);

  const load = useCallback(async () => {
    if (!beneficiaryId || beneficiaryId <= 0) {
      setBeneficiary(null);
      return;
    }

    if (!getAuthToken()) {
      setUsingApi(false);
      setBeneficiary(null);
      setError("Connectez-vous pour consulter le détail bénéficiaire.");
      return;
    }

    setLoading(true);
    setError(null);
    setUsingApi(true);

    try {
      const row = await fetchCompanyBeneficiary(type, beneficiaryId);
      setBeneficiary(row);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Bénéficiaire introuvable.";
      setError(message);
      setBeneficiary(null);
    } finally {
      setLoading(false);
    }
  }, [type, beneficiaryId]);

  useEffect(() => {
    void load();
  }, [load]);

  return { beneficiary, loading, error, usingApi, reload: load };
}
